/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    MfaCode,
    MfaCodeFromJSON,
    MfaCodeToJSON,
    MfaRegistration,
    MfaRegistrationFromJSON,
    MfaRegistrationToJSON,
    MfaRegistrationResult,
    MfaRegistrationResultFromJSON,
    MfaRegistrationResultToJSON,
    MfaRegistrationStatus,
    MfaRegistrationStatusFromJSON,
    MfaRegistrationStatusToJSON,
    MfaRemove,
    MfaRemoveFromJSON,
    MfaRemoveToJSON,
} from '../models';

export interface RegisterRequest {
    mfaCode: MfaCode;
}

/**
 * 
 */
export class MfaApi extends runtime.BaseAPI {

    /**
     * Gets MFA code for user
     */
    async getRegistrationCodeRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<MfaRegistration>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/multi-factor-authentications/registrations`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MfaRegistrationFromJSON(jsonValue));
    }

    /**
     * Gets MFA code for user
     */
    async getRegistrationCode(initOverrides?: RequestInit): Promise<MfaRegistration> {
        const response = await this.getRegistrationCodeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Registers MFA user
     */
    async registerRaw(requestParameters: RegisterRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MfaRegistrationResult>> {
        if (requestParameters.mfaCode === null || requestParameters.mfaCode === undefined) {
            throw new runtime.RequiredError('mfaCode','Required parameter requestParameters.mfaCode was null or undefined when calling register.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/multi-factor-authentications/registrations`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MfaCodeToJSON(requestParameters.mfaCode),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MfaRegistrationResultFromJSON(jsonValue));
    }

    /**
     * Registers MFA user
     */
    async register(requestParameters: RegisterRequest, initOverrides?: RequestInit): Promise<MfaRegistrationResult> {
        const response = await this.registerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get registration status
     */
    async registrationStatusRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<MfaRegistrationStatus>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/multi-factor-authentication/registrations/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MfaRegistrationStatusFromJSON(jsonValue));
    }

    /**
     * Get registration status
     */
    async registrationStatus(initOverrides?: RequestInit): Promise<MfaRegistrationStatus> {
        const response = await this.registrationStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     * Remove MFA
     */
    async removeRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<MfaRemove>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["read", "write"]);
        }

        const response = await this.request({
            path: `/v1/multi-factor-authentications/registrations`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MfaRemoveFromJSON(jsonValue));
    }

    /**
     * Remove MFA
     */
    async remove(initOverrides?: RequestInit): Promise<MfaRemove> {
        const response = await this.removeRaw(initOverrides);
        return await response.value();
    }

}
